import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faShoppingCart, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Modal from 'react-modal';
import './MobileNav.css';
import baseURL from '../url';

export default function MobileNav({ onCartOpen }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [modalWhatsapp, setModalWhatsapp] = useState(false);
    const [contactos, setContactos] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [noteText, setNoteText] = useState('¡Hola! Socios Pro..');
    const [cartItemsCount, setCartItemsCount] = useState(0); // Estado para el contador del carrito
    
    // Estados de reserva
    const [nombre, setNombre] = useState('');
    const [telefono, setTelefono] = useState('');
    const [motivo, setMotivo] = useState('');
    const [numeroPersonas, setNumeroPersonas] = useState('');
    const [fecha, setFecha] = useState('');
    const [hora, setHora] = useState('');
    const [horarios, setHorarios] = useState([]);
    const [errorHorario, setErrorHorario] = useState('');
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        cargarContacto();
        cargarHorarios();
        actualizarContadorCarrito(); // Inicializar contador del carrito

        // Intervalo para detectar cambios locales en el carrito
        const intervalId = setInterval(actualizarContadorCarrito, 1000);

        // Escuchar cambios en el localStorage (otras pestañas)
        const handleStorageChange = () => {
            actualizarContadorCarrito();
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    // Función para actualizar el contador del carrito
    const actualizarContadorCarrito = () => {
        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        setCartItemsCount(cart.length);
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse() || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarHorarios = () => {
        fetch(`${baseURL}/horariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    setHorarios(data.horarios);
                }
            })
            .catch(error => console.error('Error al cargar horarios:', error));
    };

    const validarHorario = (fechaSeleccionada, horaSeleccionada) => {
        if (!fechaSeleccionada || !horaSeleccionada) {
            return { valido: true, mensaje: '' };
        }

        const fecha = new Date(fechaSeleccionada + 'T00:00:00');
        const diaSemana = fecha.getDay();
        
        const horarioDelDia = horarios.find(h => h.dia_semana == diaSemana && h.activo == 1);
        
        if (!horarioDelDia) {
            return { 
                valido: false, 
                mensaje: 'El establecimiento está cerrado en la fecha seleccionada.' 
            };
        }

        const horaReserva = horaSeleccionada + ':00';
        let horarioValido = false;

        if (horarioDelDia.apertura1 && horarioDelDia.cierre1) {
            if (horaReserva >= horarioDelDia.apertura1 && horaReserva <= horarioDelDia.cierre1) {
                horarioValido = true;
            }
        }

        if (!horarioValido && horarioDelDia.apertura2 && horarioDelDia.cierre2) {
            if (horaReserva >= horarioDelDia.apertura2 && horaReserva <= horarioDelDia.cierre2) {
                horarioValido = true;
            }
        }

        if (!horarioValido) {
            const formatearHora = (hora) => hora ? hora.substring(0, 5) : '';
            let mensaje = 'Esta fecha y hora no están disponibles.\n\nHorarios: ';
            
            if (horarioDelDia.apertura1) {
                mensaje += `${formatearHora(horarioDelDia.apertura1)} - ${formatearHora(horarioDelDia.cierre1)}`;
            }
            
            if (horarioDelDia.apertura2) {
                mensaje += `, ${formatearHora(horarioDelDia.apertura2)} - ${formatearHora(horarioDelDia.cierre2)}`;
            }
            
            return { valido: false, mensaje };
        }

        return { valido: true, mensaje: '' };
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    const handleCartClick = () => {
        if (onCartOpen) {
            onCartOpen();
        }
    };

    const handleWhatsappMessage = () => {
        if (selectedContact || contactos?.length <= 1) {
            const phoneNumber = contactos?.length <= 1 ? contactos[0]?.telefono : selectedContact?.telefono;

            let noteMessage = '';
            if (noteText.trim() !== '') {
                noteMessage += `\n ${noteText}`;
            }

            const message = `${noteMessage}`;

            const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

            window.open(whatsappUrl, '_blank');

            setNoteText('¡Hola! Socios Pro..');
            setModalWhatsapp(false);
        }
    };

    return (
        <>
            <nav className='mobile-nav'>
                <button 
                    className={`mobile-nav-item ${isActive('/') ? 'active' : ''}`}
                    onClick={() => navigate('/')}
                >
                    <FontAwesomeIcon icon={faHome} className='mobile-nav-icon' />
                    <span>Inicio</span>
                </button>

                <button 
                    className='mobile-nav-item'
                    onClick={() => setModalWhatsapp(true)}
                >
                    <FontAwesomeIcon icon={faWhatsapp} className='mobile-nav-icon' />
                    <span>WhatsApp</span>
                </button>

                <button 
                    className='mobile-nav-item'
                    onClick={handleCartClick}
                >
                    <FontAwesomeIcon icon={faShoppingCart} className='mobile-nav-icon' />
                    {cartItemsCount > 0 && <span className='cart-badge'>{cartItemsCount}</span>}
                    <span>Carrito</span>
                </button>
            </nav>

            {/* Modal WhatsApp */}
            <Modal
                isOpen={modalWhatsapp}
                onRequestClose={() => setModalWhatsapp(false)}
                className="modal-wpp-mobile"
                overlayClassName="overlay-wpp-mobile"
            >
                <div className='containModalWpp'>
                    <div className='headerWpp'>
                        {contactos.length > 1 ? (
                            <span>Selecciona un teléfono</span>
                        ) : (
                            <span>Envíanos un mensaje</span>
                        )}
                        <button onClick={() => setModalWhatsapp(false)} className='closeBtn'>
                            X
                        </button>
                    </div>
                    <div className='mensaje'>
                        <p>Hola, ¿en qué podemos ayudarte? 👋</p>
                    </div>

                    <div className='btnsWpp'>
                        {contactos.length > 1 && (
                            <div className='btnsWpp'>
                                {contactos.map(item => (
                                    <button
                                        key={item.idContacto}
                                        className='btnWpp'
                                        style={{ backgroundColor: selectedContact && selectedContact.idContacto === item.idContacto ? 'green' : '' }}
                                        onClick={() => setSelectedContact(item)}
                                    >
                                        {item.telefono}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className='sendWpp'>
                        <textarea
                            placeholder="Envíanos un mensaje"
                            value={noteText}
                            onChange={(e) => setNoteText(e.target.value)}
                        />
                        <button onClick={handleWhatsappMessage}>
                            <FontAwesomeIcon icon={faWhatsapp} />
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
}

